import { render } from "./RecordView.vue?vue&type=template&id=09c816f7&scoped=true"
import script from "./RecordView.vue?vue&type=script&lang=js"
export * from "./RecordView.vue?vue&type=script&lang=js"

import "./RecordView.vue?vue&type=style&index=0&id=09c816f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c816f7"]])

export default __exports__